/**
 * Makes the theme's predictive search behave as an inline combobox.
 *
 * The component was written for the search modal, where it owns the keyboard
 * and the results are the only thing on screen. Inline in the header that
 * turns into two bugs, both handled here without touching the component:
 *
 * - Tab: the component cycles results on Tab instead of letting focus leave,
 *   which traps keyboard users in the header field. Tab is kept away from it,
 *   and so is every other key while the dropdown is closed — otherwise
 *   ArrowDown and Enter pick a result nobody can see.
 * - WebKit: Safari, and every browser on iOS, does not focus a link on click,
 *   so pressing one moves focus off the field. The dropdown is shown only
 *   while the search has focus, so it vanished before the click landed and
 *   results could not be clicked at all. Pressing inside the dropdown now
 *   keeps focus in the field.
 *
 * Both listeners sit on the document, so they survive the header being
 * re-rendered by the theme editor.
 */

const COMPONENT_SELECTOR = '.header-search__component';
const RESULTS_SELECTOR = '.header-search__results';

/** @param {Element} component */
function dropdownIsOpen(component) {
  const results = component.querySelector(RESULTS_SELECTOR);
  return results instanceof HTMLElement && getComputedStyle(results).display !== 'none';
}

document.addEventListener(
  'keydown',
  (event) => {
    const component = event.target instanceof Element ? event.target.closest(COMPONENT_SELECTOR) : null;
    if (!component) return;

    // Capture phase on the document runs before the component's own handler;
    // stopping here leaves the browser's default (moving focus, submitting
    // the form on Enter) in place.
    if (event.key === 'Tab' || !dropdownIsOpen(component)) event.stopPropagation();
  },
  true
);

document.addEventListener('mousedown', (event) => {
  if (event.target instanceof Element && event.target.closest(RESULTS_SELECTOR)) event.preventDefault();
});
